<template>
  <page-wrapper
    :isLoading="isLoading"
    :isExtended="true"
    :hasFilters="true"
    @submitFilters="setPageNumberAndGetMasterSalaries"
  >
    <template #title> لیست درآمد اساتید </template>
    <template #filters>
      <search-input
        inputId="userFullname"
        inputLabel="جستجو بر اساس نام استاد"
        inputPlaceholder="جستجوی نام..."
        v-model="masterSalariesFilters.masterUserFullname"
        @enter="setPageNumberAndGetMasterSalaries"
      ></search-input>
      <search-input
        inputId="userMobile"
        inputLabel="جستجو بر اساس شماره استاد"
        inputPlaceholder="0912..."
        v-model="masterSalariesFilters.masterUserMobile"
        @enter="setPageNumberAndGetMasterSalaries"
      ></search-input>
      <search-input
        inputId="studentUserFullname"
        inputLabel="جستجو بر اساس نام زبان آموز"
        inputPlaceholder="جستجوی نام..."
        v-model="masterSalariesFilters.studentUserFullname"
        @enter="setPageNumberAndGetMasterSalaries"
      ></search-input>
      <search-input
        inputId="studentUserMobile"
        inputLabel="جستجو بر اساس شماره زبان آموز"
        inputPlaceholder="جستجوی شماره..."
        v-model="masterSalariesFilters.studentUserMobile"
        @enter="setPageNumberAndGetMasterSalaries"
      ></search-input>
      <range-date-picker
        inputId="fromToDateRange"
        class="w-24 filters-width"
        label="بازه تاریخ درآمد (بر اساس تاریخ ثبت کلاس)"
        @getDateRange="setFromToDateRange"
      ></range-date-picker>
      <range-date-picker
        inputId="fromToScheduleDateRange"
        class="w-24 filters-width"
        label="بازه تاریخ درآمد (بر اساس تاریخ شروع کلاس)"
        @getDateRange="setFromToScheduleDateRange"
      ></range-date-picker>
      <price-category-picker
        @getPriceCategory="setPriceCategory"
        class="w-24 filters-width mr-md-2"
      ></price-category-picker>
    </template>
    <template #extend>
      <div>
        <p>
          جمع دقایق تدریس شده:‌
          <span class="text-primary">
            {{ Intl.NumberFormat("en-US").format(sumMinute) }}
          </span>
          دقیقه
        </p>
        <p>
          جمع درآمد اساتید:
          <span class="text-primary">
            {{ Intl.NumberFormat("en-US").format(sumPrice) }}
          </span>
          تومان
        </p>
      </div>
    </template>
    <custom-table
      :pageNumber="masterSalariesFilters.pageNumber"
      :count="masterSalariesFilters.count"
      :totalCount="totalCount"
      :tableColumns="myTableColumns"
      :tableItems="salariesList"
      @changePage="changePage"
    >
      <template #masterUserFullname="data">
        <b-link :to="`/users/${data.item.masterUserId}`">
          {{ data.item.masterUserFullname }}
        </b-link>
      </template>
      <template #sumPrice="data">
        {{ Intl.NumberFormat("en-US").format(data.item.sumPrice) }}
        تومان
      </template>
      <template #sCount="data">
        {{ data.item.sCount }}
        جلسه
      </template>
      <template #priceCategoryTitles="data">
        <template
          v-if="
            data.item.priceCategoryTitles &&
            data.item.priceCategoryTitles.length > 0
          "
        >
          <template v-for="(category, index) in data.item.priceCategoryTitles">
            {{ category }}
            {{ index + 1 < data.item.priceCategoryTitles.length ? "-" : "" }}
          </template>
        </template>
        <template v-else>-</template>
      </template>
      <template #actions="data">
        <b-link :to="generateRouteObj(data.item.masterUserId)">
          <feather-icon icon="ExternalLinkIcon" size="20" />
        </b-link>
      </template>
    </custom-table>
  </page-wrapper>
</template>

<script>
export default {
  mounted() {
    if (
      this.$route.query &&
      this.$route.query.fromDate &&
      this.$route.query.toDate
    ) {
      this.masterSalariesFilters.fromDate = new Date(
        +this.$route.query.fromDate
      )
        .toISOString()
        .split("T")[0];
      this.masterSalariesFilters.toDate = new Date(+this.$route.query.toDate)
        .toISOString()
        .split("T")[0];
      this.dateRangeFrom = [
        new Date(+this.$route.query.fromDate).toISOString().split("T")[0],
        new Date(+this.$route.query.toDate).toISOString().split("T")[0],
      ];
    }
    Object.keys(this.masterSalariesFilters).forEach((key) => {
      if (this.$route.query[key]) {
        this.masterSalariesFilters[key] = this.$route.query[key];
      }
    });
    this.getAllMastersSalaries();
  },
  data() {
    return {
      isLoading: false,
      masterSalariesFilters: {
        pageNumber: 1,
        count: 10,
        masterUserFullname: null,
        masterUserMobile: null,
        fromDate: null,
        toDate: null,
        fromDateSchedule: null,
        toDateSchedule: null,
        studentUserFullname: null,
        studentUserMobile: null,
        masterUserId: null,
        studentUserId: null,
        priceCategoryId: null,
      },
      myTableColumns: [
        {
          key: "masterUserId",
          label: "شناسه استاد",
        },
        {
          key: "masterUserFullname",
          label: "نام استاد",
        },
        {
          key: "masterUserMobile",
          label: "شماره استاد",
        },
        {
          key: "sumPrice",
          label: "جمع درآمد",
        },
        {
          key: "sCount",
          label: "تعداد جلسات",
        },
        {
          key: "priceCategoryTitles",
          label: "گروهبندی",
        },
        {
          key: "actions",
          label: "جزئیات",
        },
      ],
      salariesList: null,
      sumPrice: null,
      sumMinute: null,
      totalCount: null,
      dateRangeFrom: null,
      dateRangeSchedule: null,
    };
  },
  methods: {
    changePage(pageNumber) {
      this.masterSalariesFilters.pageNumber = pageNumber;
      this.getAllMastersSalaries();
    },
    setFromToDateRange(dateRange) {
      if (dateRange && dateRange.length > 0) {
        this.dateRangeFrom = dateRange;
      } else {
        this.clearDateRangeFrom();
      }
    },
    setFromToScheduleDateRange(dateRange) {
      if (dateRange && dateRange.length > 0) {
        this.dateRangeSchedule = dateRange;
      } else {
        this.clearDateRangeSchedule();
      }
    },
    generateRouteObj(masterUserId) {
      let requiredQueryKeys = [
        "fromDate",
        "toDate",
        "fromDateSchedule",
        "toDateSchedule",
        "priceCategoryId",
        "studentUserId",
        "studentUserFullname",
        "studentUserMobile",
      ];
      let queries = {};
      requiredQueryKeys.forEach((key) => {
        if (this.masterSalariesFilters[key]) {
          if (this.masterSalariesFilters[key].constructor == Date) {
            queries[key] = Date.parse(
              new Date(this.masterSalariesFilters[key])
            );
          } else {
            queries[key] = this.masterSalariesFilters[key];
          }
        }
      });
      return {
        path: `/users/masters-salary/${masterUserId}`,
        query: queries,
      };
    },
    setPageNumberAndGetMasterSalaries() {
      this.masterSalariesFilters.pageNumber = 1;
      this.calculateDates();
      let requiredQueryKeys = [
        "fromDate",
        "toDate",
        "fromDateSchedule",
        "toDateSchedule",
        "priceCategoryId",
        "studentUserId",
        "studentUserFullname",
        "studentUserMobile",
      ];
      let queries = {};
      requiredQueryKeys.forEach((key) => {
        if (this.masterSalariesFilters[key]) {
          if (this.masterSalariesFilters[key].constructor == Date) {
            queries[key] = Date.parse(
              new Date(this.masterSalariesFilters[key])
            );
          } else {
            queries[key] = this.masterSalariesFilters[key];
          }
        }
      });
      this.$router.push({
        path: this.$route.path,
        query: queries,
      });
      this.getAllMastersSalaries();
    },
    setPriceCategory(priceCategoryId) {
      this.masterSalariesFilters.priceCategoryId = priceCategoryId;
    },
    clearDateRangeFrom() {
      this.dateRangeFrom = null;
      this.masterSalariesFilters.fromDate = null;
      this.masterSalariesFilters.toDate = null;
    },
    clearDateRangeSchedule() {
      this.dateRangeSchedule = null;
      this.masterSalariesFilters.fromDateSchedule = null;
      this.masterSalariesFilters.toDateSchedule = null;
    },
    calculateDates() {
      if (this.dateRangeFrom && this.dateRangeFrom.length > 0) {
        this.masterSalariesFilters.fromDate = new Date(this.dateRangeFrom?.[0]);
        this.masterSalariesFilters.toDate = new Date(this.dateRangeFrom?.[1]);
      }
      if (this.dateRangeSchedule && this.dateRangeSchedule.length > 0) {
        this.masterSalariesFilters.fromDateSchedule = new Date(
          this.dateRangeSchedule?.[0]
        );
        this.masterSalariesFilters.toDateSchedule = new Date(
          this.dateRangeSchedule?.[1]
        );
      }
    },
    async getAllMastersSalaries() {
      try {
        this.calculateDates();
        this.isLoading = true;
        let _this = this;
        let getMainReportList = new GetMainReportList(_this);
        getMainReportList.setRequestParamDataObj(_this.masterSalariesFilters);
        await getMainReportList.fetch((res) => {
          _this.salariesList = res.data;
          _this.totalCount = res.total;
          _this.sumMinute = res.sumMinute;
          _this.sumPrice = res.sumPrice;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BLink,
    PriceCategoryPicker,
    PageWrapper,
    SearchInput,
    RangeDatePicker,
    CustomTable,
  },
};
import { BLink } from "bootstrap-vue";
import PriceCategoryPicker from "@/views/apps/PriceCategory/PriceCategoryPicker.vue";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import RangeDatePicker from "@/views/components/Utils/RangeDatePicker.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import { GetMainReportList } from "@/libs/Api/MasterUserPayment";
</script>